module.exports = __webpack_public_path__ + "static/media/DSC_0041 (2).3dd8b039.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0041 (2).jpg
// module id = 547
// module chunks = 0